import React from "react";
import { useAppState } from "@v2/app-state";
import { observer } from "mobx-react";
import { Modal } from "@fluentui/react";
import { useStyles } from "./DialogContext.styles";

export const DialogContext: React.FC = observer(() => {
  const appState = useAppState();
  const styles = useStyles();

  return (
    <>
      <Modal
        isOpen={!!appState.dialogContent}
        onDismiss={() => appState.dialogContent = null}
        containerClassName={styles.dialogContext}
        scrollableContentClassName={styles.content}
      >
        {appState.dialogContent}
      </Modal>
    </>
  )
});
